import React from "react"

import SpinnerImage from "../../../../common/SpinnerImage"
import WidgetHeaderButton from "../../../../common/WidgetHeaderButton"
import SearchBar from "../../../../common/SearchBar"
import CommunityEditParticipantsListContainer from "./CommunityEditParticipantsListContainer"

const CommunityEditPartipants = ({
    type,
    communityId,
    isAdding,
    canApply,
    participantTypes,
    selectedParticipantType,
    searchTerm,
    pagingRequest,
    onTypeChange,
    onSearch,
    cancelAdding,
    addSelected
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-community-people" /> People
            {pagingRequest &&
                pagingRequest.isFetching && <SpinnerImage isCentral={false} />}
            {isAdding && (
                <div className="pull-right">
                    <WidgetHeaderButton
                        disabled={!canApply}
                        onClick={addSelected}
                    >
                        Apply
                    </WidgetHeaderButton>
                    <WidgetHeaderButton
                        isSecondary={true}
                        onClick={cancelAdding}
                    >
                        Cancel
                    </WidgetHeaderButton>
                </div>
            )}
        </h3>
        <div className="search-bar-container">
            <SearchBar
                searchTerm={searchTerm}
                placeholder="search to add members"
                onSearch={onSearch}
            />
        </div>
        {!isAdding && (
            <select
                className="form-control"
                value={selectedParticipantType}
                onChange={onTypeChange(pagingRequest)}
            >
                {participantTypes.map(({ label, value }) => (
                    <option key={value} value={value}>
                        {label}
                    </option>
                ))}
            </select>
        )}
        <CommunityEditParticipantsListContainer
            type={type}
            communityId={communityId}
            isAdding={isAdding}
        />
    </div>
)

export default CommunityEditPartipants
